import React, { useState } from 'react';
import { Box, Button, Flex, Text } from '@radix-ui/themes';
import * as Toast from '@radix-ui/react-toast';
import { shareToSNS, copyToClipboard } from 'utils/shareUtils';
import './style.scss';

export default function SocialShare({ title, url, description, imageUrl }) {
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const handleShare = async platform => {
    try {
      if (platform === 'copy') {
        const success = await copyToClipboard(url);
        if (success) {
          setToastMessage('링크가 클립보드에 복사되었습니다.');
        } else {
          setToastMessage('클립보드 복사에 실패했습니다.');
        }
        setToastOpen(true);
        setTimeout(() => setToastOpen(false), 3000);
      } else {
        shareToSNS(platform, { title, url, description, imageUrl });
      }
    } catch (error) {
      console.error('공유 중 오류 발생:', error);
      setToastMessage(error.message || '공유 중 오류가 발생했습니다.');
      setToastOpen(true);
      setTimeout(() => setToastOpen(false), 3000);
    }
  };

  const shareButtons = [
    {
      platform: 'kakao',
      name: '카카오톡',
      icon: 'kakao'
    },
    {
      platform: 'facebook',
      name: '페이스북',
      icon: 'facebook'
    },
    {
      platform: 'naver',
      name: '네이버 공유하기',
      icon: 'naver'
    },
    {
      platform: 'band',
      name: '네이버 밴드',
      icon: 'band'
    },
    {
      platform: 'copy',
      name: '링크 복사',
      icon: 'copy'
    }
  ];

  return (
    <Toast.Provider swipeDirection="right">
      <Box className="social-share">
        <Flex gap="2" wrap="wrap" align="center">
          {shareButtons.map(button => (
            <Button
              key={button.platform}
              variant="soft"
              className={`share-button ${button.platform}`}
              onClick={() => handleShare(button.platform)}
              aria-label={`${button.name}으로 공유하기`}
              title={`${button.name}으로 공유하기`}
            >
              <Text className={`icon icon-${button.icon}`} aria-hidden="true"></Text>
              <Text className="sr-only">{button.name}</Text>
            </Button>
          ))}
        </Flex>
        <Toast.Root className="toast-root" open={toastOpen} onOpenChange={setToastOpen}>
          <Toast.Title className="toast-title">{toastMessage}</Toast.Title>
        </Toast.Root>
        <Toast.Viewport className="toast-viewport" />
      </Box>
    </Toast.Provider>
  );
}
